import React, { useEffect, useState } from "react";
import sopGuideAPI from "../../../api/admin/sopGuideApi";

function SopGuide() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetchSopGuidelinesData();
  }, []);

  const fetchSopGuidelinesData = async () => {
    const res = await sopGuideAPI.getAll();

    if (res.code === 200) {
      setItems(res.data);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col-md-4">
                  <h3 className="page-title">SOP Guide</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h5 className="card-title">Guidelines</h5>
              </div>
              <div className="card-body">
                <div className="accordion" id="accordionExample">
                  {items.map((item, index) => (
                    <div className="accordion-item" key={item._id}>
                      <h2 className="accordion-header" id={`heading${index}`}>
                        <button
                          className="accordion-button text-dark fw-bold"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse${index}`}
                          aria-expanded={index === 0 ? "true" : "false"}
                          aria-controls={`collapse${index}`}
                        >
                          {item.title}
                        </button>
                      </h2>
                      <div
                        id={`collapse${index}`}
                        className={`accordion-collapse collapse ${
                          index === 0 ? "show" : ""
                        }`}
                        aria-labelledby={`heading${index}`}
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          {item.attachments && item.attachments.length > 0 ? (
                            item.attachments.map((att, index) => (
                              <a
                                key={index}
                                target="_blank"
                                href={att.url} // jo url tu backend me bhej raha hai
                                className="btn btn-primary m-1"
                                download
                              >
                                Download {item.title}
                              </a>
                            ))
                          ) : (
                            <span>No attachments</span>
                          )}

                          <div
                            className="description"
                            dangerouslySetInnerHTML={{
                              __html: item?.description,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SopGuide;
